import { User, UserDtoFromJwt } from '../types/User'

const JWT_LOCAL_STORAGE_KEY = 'jwtToken'

export function saveUserToken(jwtToken: string): void {
  localStorage.setItem(JWT_LOCAL_STORAGE_KEY, jwtToken)
}

export function getUserToken(): string {
  const token = localStorage.getItem(JWT_LOCAL_STORAGE_KEY)
  return token ? token : ''
}

export function loadUserFromJwtString(jwtToken: string): User {
  const dto = parseJwt(jwtToken) as UserDtoFromJwt
  const user: User = {
    email: dto.email,
    exp: dto.exp,
    id: dto.id,
    fullName: "test user",  
    customerId: dto.customerId 
  }
  return user
}

export function isExpiredToken(expiryDate: number): boolean {
  const date = new Date()
  const now_utc = Date.UTC(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds(),
  )
  return now_utc > expiryDate * 1000
}

function parseJwt(token: string): object {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => {
        return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`
      })
      .join(''),
  )

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return JSON.parse(jsonPayload)
}
